import { useEffect } from 'react';
import { setHeaderBg, setHeaderLinkTextColor, setHeaderContrastTextColor } from '~/utils/styles/setHeaderBg';

import * as variables from '~/styles/variables.scss';

export const useHeaderColorChanger = (
    color: string,
    linkTextColor = variables.componentHeaderColorLinkTextDefault,
    contrastTextColor = variables.componentHeaderColorContrastTextDefault
) => {
    useEffect(() => {
        setHeaderBg(color ? color : variables.componentHeaderColorDefault);
        setHeaderLinkTextColor(linkTextColor);
        setHeaderContrastTextColor(contrastTextColor);

        return () => {
            setHeaderBg(variables.componentHeaderColorDefault);
            setHeaderLinkTextColor(variables.componentHeaderColorLinkTextDefault);
            setHeaderContrastTextColor(variables.componentHeaderColorContrastTextDefault);
        };
    }, [color, linkTextColor, contrastTextColor]);
};
